import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByRooms = (rooms?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!rooms || Number.isNaN(rooms)) {
        return null;
    }

    switch (rooms) {
        case 1: {
            const key = "properties_1room" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 1 pokojem",
                      ...statsValue
                  }
                : null;
        }
        case 2: {
            const key = "properties_2rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 2 pokojami",
                      ...statsValue
                  }
                : null;
        }
        case 3: {
            const key = "properties_3rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 3 pokojami",
                      ...statsValue
                  }
                : null;
        }
        case 4: {
            const key = "properties_4rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 4 pokojami",
                      ...statsValue
                  }
                : null;
        }
        default:
            const key = "properties_5rooms_or_more" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 5 pokojami lub więcej",
                      ...statsValue
                  }
                : null;
    }
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByRooms = (rooms?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!rooms || Number.isNaN(rooms)) {
        return null;
    }

    switch (rooms) {
        case 1: {
            const key = "properties_1room" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 1 pokojem",
                      ...statsValue
                  }
                : null;
        }
        case 2: {
            const key = "properties_2rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 2 pokojami",
                      ...statsValue
                  }
                : null;
        }
        case 3: {
            const key = "properties_3rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 3 pokojami",
                      ...statsValue
                  }
                : null;
        }
        case 4: {
            const key = "properties_4rooms" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 4 pokojami",
                      ...statsValue
                  }
                : null;
        }
        default:
            const key = "properties_5rooms_or_more" as const;
            const statsValue = stats?.[key];

            return statsValue && statsValue.total
                ? {
                      key,
                      label: "z 5 pokojami lub więcej",
                      ...statsValue
                  }
                : null;
    }
};
